import { useNavigate, useParams } from 'react-router-dom';

import { Flex } from 'shared_DEPRECATED/components/Flex';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { SessionSidebarFieldset } from 'features/sessions/components';

import { Button, ButtonIcon } from 'shared/components/Button';
import { sidebar } from 'shared/components/Sidebar';
import { Typography } from 'shared/components/Typography';

export const NextSessionSidebarHeader = ({
  clientEmail,
  coachingSessionId,
  onNextSessionSave,
}: {
  clientEmail: string;
  coachingSessionId: string;
  onNextSessionSave: () => Promise<void>;
}) => {
  const navigate = useNavigate();
  const { email: emailFromParams } = useParams();

  const participantEmail = clientEmail || emailFromParams;

  const handleClick = async () => {
    await onNextSessionSave();
    sidebar.close();

    navigate(
      `/hde/participants/${participantEmail}/sessions/${coachingSessionId}`
    );
  };

  return (
    <SessionSidebarFieldset>
      <Flex alignItems="center">
        <Flex justifyContent="space-between">
          <ButtonIcon
            aria-label="close sidebar"
            variant="ghost"
            data-testid="next-session-sidebar-close-button"
            onClick={() => {
              sidebar.close();
            }}
            size="sm"
          >
            <Icon name={iconNames.chevronRight} />
          </ButtonIcon>
          <Spacer size="sm" />
          <Typography color="black" as="h3">
            Next session notes
          </Typography>
        </Flex>
        <Button
          onClick={handleClick}
          variant="ghost"
        >
          <Typography color="blue" type="meta">
            View full notes
          </Typography>
        </Button>
      </Flex>
    </SessionSidebarFieldset>
  );
};
